import { Button, InputText } from "@sellar-io/components";
import { ReactElement } from "react";
import { useForm } from "react-hook-form";
import {
  generateBusinessFormFieldValues,
  generateBusinessRequest,
} from "~/forms/business/BusinessFormValues";
import { apiV2AssertError } from "~/hooks/api/v2/apiV2Request";
import { useBusinessUpdate } from "~/hooks/api/v2/business/useBusinessUpdate";
import { useSellarCurrentBusiness } from "../../../hooks/useSellarCurrentBusiness.shared";
import { Alert } from "../../alert/Alert";
import { InputLabel, InputContainer } from "@sellar-io/components";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../modal/Dialog";
import { SpinnerLegacy } from "../..";

export function OrderCreateConsignmentUpdateSupplierDetailsModal({
  onDismiss,
  active,
  email,
  phoneNumber,
  businessId,
}: {
  onDismiss: () => void;
  active: boolean;
  email: string;
  phoneNumber: string | null;
  businessId: number;
}): ReactElement {
  const { business } = useSellarCurrentBusiness();

  if (!business?.Supplier) throw new Error("Business type not allowed.");
  const form = useForm({
    shouldUseNativeValidation: true,
    defaultValues: {
      email,
      phoneNumber,
    },
  });

  const businessUpdateMutation = useBusinessUpdate(businessId);

  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        title={"Edit contact details"}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />
      <DialogContent>
        <>
          {businessUpdateMutation.isPending ? (
            <SpinnerLegacy />
          ) : (
            <>
              {businessUpdateMutation.isError && (
                <Alert
                  type={"error"}
                  message={
                    apiV2AssertError(businessUpdateMutation.error)?.response
                      ?.data.message ?? "An unknown error occurred"
                  }
                />
              )}
              <form
                onSubmit={form.handleSubmit((data) => {
                  const formFields = generateBusinessFormFieldValues(business);
                  const request = generateBusinessRequest(
                    formFields,
                    "supplier",
                  );
                  businessUpdateMutation.mutate(
                    {
                      ...request,
                      email: data.email,
                      phoneNumber: data.phoneNumber,
                    },
                    {
                      onSuccess: () => onDismiss(),
                    },
                  );
                })}
                className={"flex flex-col gap-4"}
              >
                <InputLabel>Contact Email</InputLabel>
                <InputContainer>
                  <InputText {...form.register("email", { required: true })} />
                </InputContainer>
                <InputLabel>Phone number</InputLabel>
                <InputContainer>
                  <InputText
                    {...form.register("phoneNumber", { required: false })}
                  />
                </InputContainer>
                <DialogCTA>
                  <Button type="submit">Update</Button>
                </DialogCTA>
              </form>
            </>
          )}
        </>
      </DialogContent>
    </Dialog>
  );
}
